export type InboxRequestParams = (string | number)[];

export interface InboxStatus {
  assignmentCount: number;
}

export type InboxTableColumnId =
  | "touchpointName"
  | "publishLabel"
  | "clientName"
  | "lastModifiedDate"
  | "openCommentCount"
  | "campaignName"
  | "touchpointVersionStatus"
  | "campaignAudiences";

export interface InboxTableColumn {
  label: string;
  id: InboxTableColumnId;
  isSortable?: boolean;
  isDisplayed?: boolean;
  width?: string;
}

export type InboxTableColumns = (InboxTableColumn | null)[];

export enum QuickFilterTypes {
  hasOpenActionItems = "has-open-action-items",
  toReview = "to-review",
}

export interface ActiveAllFilters {
  filterType: ClientFilterTypes | FilterTypes;
  appliedFilters: AppliedFilter[];
}

export interface AppliedFilter {
  value: string;
}
export enum FilterTypes {
  clientReviewStatus = "client-review-status",
  creativeType = " creative-type",
  contentTypes = " content-types",
  comments = "comments",
  clients = " clients",
}
export enum ClientFilterTypes {
  campaign = "campaign",
  programType = "program-type",
  theme = "theme",
}

export interface InboxFilter {
  campaignIds?: InboxRequestParams;
  clientIds?: InboxRequestParams;
  contentTypes?: InboxRequestParams;
  hasActionItems?: boolean | null;
  hasOpenActionComments?: boolean | null;
  hasOpenComments?: boolean | null;
  programTypes?: InboxRequestParams;
  themeIds?: InboxRequestParams;
  touchpointBatchId?: InboxRequestParams;
  touchpointBatchName?: InboxRequestParams;
  types?: InboxRequestParams;
  userRoles?: InboxRequestParams;
  touchpointVersionStatus?: InboxRequestParams;
  touchpointType?: string[];
  q?: string;
  clientId?: string[];
  touchpointContentType?: string[];
  populationType?: string[];
  classes?: string[];
}
